import { User } from '@/models/User';
import { Component, Vue } from 'vue-property-decorator';
import MiForm, { MiFormField } from '@/components/MiForm/MiForm';
import { isArray, isEmpty } from 'lodash';
import { object as dotObject } from 'dot-object';

@Component<AbstractFilter>({ })
export default class AbstractFilter extends Vue {
  protected filteredFields: MiFormField[] = [];

  protected handleFilterSubmit(field: MiFormField): void {
    if (! field) {
      return;
    }
    if (this.isEmptyValue(field.value)) {
      this.removeFilteredField(field);
      return;
    }

    this.addOrUpdateFilteredFields(field);
  }

  protected removeFilter(key: string): void {
    this.filteredFields = this.filteredFields.filter((field: MiFormField): boolean => field.key !== key);

    this.clearField(key);
  }

  protected removeFilterValue(key: string, value: string): void {
    const field = this.filteredFields.find((currentfield: MiFormField): boolean => currentfield.key === key);
    if (! field) { return; }

    // last value in array remove complet filter
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((field.value as any[]).length === 1) { this.removeFilter(key); }

    // if field values are  an object array
    if (field.returnObject) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      field.value = (field.value as any[]).filter((currentValue: any): boolean => currentValue[field.itemText as string] !== value);
    } else {
      field.value = (field.value as string[]).filter((currentValue: string): boolean => currentValue !== value);
    }
  }

  protected clearFilters(): void {
    this.filteredFields = [];
    if (! this.filterForm) { return; }
    this.filterForm.refreshFields();
  }

  protected clearField(key: string): void {
    if (! this.filterForm) { return; }
    this.filterForm.clearFieldByKey(key);
  }

  protected isEmptyValue(value: unknown): boolean {
    if (isArray(value)) {
      const definedValues = value.filter((currentValue: unknown): boolean => ! isEmpty(currentValue));
      return definedValues.length < 1;
    }

    return isEmpty(`${value}`);
  }

  protected removeFilteredField(field: MiFormField): void {
    this.filteredFields = this.filteredFields
      .filter((currentField: MiFormField) => currentField.key !== field.key);
  }

  protected addOrUpdateFilteredFields(field: MiFormField): void {
    if (! field.value) { return; }

    if (this.filteredFields.some((currentField: MiFormField): boolean => currentField.key === field.key)) {
      this.updateFilteredField(field);
      return;
    }

    this.filteredFields.push(field);
  }

  protected updateFilteredField(field: MiFormField): void {
    const index = this.filteredFields.findIndex((currentField: MiFormField) => currentField.key === field.key);
    if (index < 0) { return; }

    this.filteredFields.splice(index, 1, field);
  }

  protected get filterFields(): MiFormField[] {
    return [

    ];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected miFormFiltersToPayload(): {[key: string]: any} {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let parsedFilters: any = {};

    this.filteredFields.forEach((field: MiFormField): void => {
      if (! field.value) {
        this.removeFilter(field.key);
      }
      if (! field.returnObject) {
        if (field.type === 'date_range') {
          const dates = field.value as Record<string, string>;
          parsedFilters[field.key] = { from: dates[0], to: dates[1] };
        } else {
          parsedFilters[field.key] = field.value;
        }
      } else if (! isArray(field.value)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        parsedFilters[field.key] = field.value ? (field.value as any)[field.itemValue || 'id'] : '';
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const values = field.value ? (field.value as any).map((currentValue: any): any => currentValue[field.itemValue || 'id']) : '';
        parsedFilters[field.key] = values;
      }
    });

    // parse array notation like range[0] &  range[1]
    parsedFilters = dotObject(parsedFilters);

    // remove range or dwelling field if they have only 1 value;
    if (parsedFilters.range && parsedFilters.range.length < 2) {
      delete parsedFilters.range;
    }

    if (parsedFilters.dwelling && parsedFilters.dwelling.length < 2) {
      delete parsedFilters.dwelling;
    }

    return parsedFilters;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected get filters(): {[key: string]: any} {
    return this.miFormFiltersToPayload();
  }

  protected get filterForm(): MiForm | null {
    const filterForm: MiForm = this.$refs.filterForm as MiForm;
    if (! filterForm) { return null; }

    return filterForm;
  }

  public get Auth(): User|null {
    return this.$store.getters.user;
  }
}
